import { render, staticRenderFns } from "./scanningCode.vue?vue&type=template&id=3499389e&scoped=true"
import script from "./scanningCode.vue?vue&type=script&lang=js"
export * from "./scanningCode.vue?vue&type=script&lang=js"
import style0 from "./scanningCode.vue?vue&type=style&index=0&id=3499389e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3499389e",
  null
  
)

export default component.exports